import React from 'react'

const Album = () => {
  return (
    <>
      <div class="featured_album">
		{/* <div class="background_image featured_background" style={{"background-image":"url(images/featured_album.jpg)"}}></div> */}
		<div class="container">
			<div class="row">
				<div class="col-lg-6 offset-lg-6">
					<div class="section_title_container">
						<div class="section_subtitle">Events</div>
						<div class="section_title"><h1>Featured E.P</h1></div>
					</div>
				</div>
			</div>
			<div class="row featured_row row-lg-eq-height">

				<div class="col-md-6">
					<div class="featured_album_image">
						<div class="image_overlay"></div>
						<div class="background_image" style={{"background-image":"url(images/dani2.jpg)"}}></div>
						 {/* <img src="images/featured_album.jpg" alt=""/>  */}
					</div>
				</div>

				<div class="col-md-6 featured_album_col">
					<div class="featured_album_player_container d-flex flex-column align-items-start justify-content-center">
						<div class="featured_album_player">
							<div class="featured_album_title_bar d-flex flex-row align-items-center justify-content-start">
								<div class="featured_album_title_container">
									<div class="featured_album_artist">DANII</div>
									<div class="featured_album_title">Turning On Its Own</div>
								</div>
								<div class="featured_album_link ml-auto"><a href="#">Stream On All Platforms</a></div>
							</div>
							<div id="jplayer_1" class="jp-jplayer"></div>
							<div id="jp_container_1" class="jp-audio" role="application" aria-label="media player">
								<div class="jp-type-playlist">
									<div class="jp-playlist">
										<ul>
											<li></li>
										</ul>
									</div>
									<div class="player_details d-flex flex-row align-items-center justify-content-start">
										<div class="jp-details">
											<div>playing</div>
											<div class="jp-title" aria-label="title">&nbsp;</div>
										</div>
										<div class="jp-controls-holder ml-auto">
											<button class="jp-play" tabindex="0"></button>
										</div>
									</div>
									<div class="player_controls">
										<div class="jp-gui jp-interface d-flex flex-row align-items-center justify-content-start">
											<div class="jp-controls-holder time_controls d-flex flex-row align-items-center justify-content-start">
												<div><div class="jp-current-time" role="timer" aria-label="time">&nbsp;</div></div>
												<div class="jp-progress">
													<div class="jp-seek-bar">
														<div class="jp-play-bar"></div>
													</div>
												</div>
												<div><div class="jp-duration ml-auto" role="timer" aria-label="duration">&nbsp;</div></div>
											</div>
											<div class="jp-volume-controls d-flex flex-row align-items-center justify-content-start ml-auto">
												<button class="jp-mute" tabindex="0"></button>
												<div class="jp-volume-bar">
													<div class="jp-volume-bar-value"></div>
												</div>
											</div>
										</div>
									</div>
									<div class="jp-no-solution">
										<span>Update Required</span>
										To play the media you will need to either update your browser to a recent version or update your <a href="http://get.adobe.com/flashplayer/" target="_blank">Flash plugin</a>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

			</div>
		</div>
	</div>

    </>
  )
}

export default Album
